const MAX_32BIT_INT = 0x7fffffff;

const HASH_LENGTH = 5;

// 5-char non-cryptographic IDs: readable in JSON, collision risk acceptable for quick keys.
// Simple hash algorithm similar to djb2
export const simpleHash = (input: string): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << HASH_LENGTH) + hash + input.charCodeAt(i)) & MAX_32BIT_INT;
  }
  let result = '';
  for (let i = 0; i < HASH_LENGTH; i++) {
    result += chars[hash % chars.length];
    hash = Math.floor(hash / chars.length);
  }
  return result;
};

